import { mapState, mapActions } from 'vuex';

export default {

  computed: {
    ...mapState({
      adminPost: (state) => state.fetcherAdminPost.fetcherAdminPost,
    }),
  },

  mounted() {
    // console.log('post.pid', this.$route.params.pid);

    if (this.$route.params.pid !== null) {
      if (this.$auth.check()) {
        this.loadFetcherAdminPost();
      }
    }
  },

  methods: {
    ...mapActions(['getFetcherAdminPost']),

    async loadFetcherAdminPost() {
      try {
        await this.getFetcherAdminPost({
          params: {
            pid: this.$route.params.pid,
          },
        });

        // console.log('post', this.post);

        // success
        // console.log('success loading post!');
      } catch (error) {
        // error
        // console.log('error loading post!');
      }
    },
  },

};
